import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { userStore } from '../user.store';

@Injectable({ providedIn: 'root' })
export class MailPreferenceResolver {
  readonly store = inject(userStore);

  constructor() {}
  resolve: ResolveFn<void> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void => {
    this.store.getMailPreferences();
  };
}
